import type { ListingStatus } from "@nova-ai/shared"

import { cn } from "../../lib/utils"
import { StatusBadge, type BadgeTone } from "../ui/status-badge"
import { RUN_STATUS_LABELS } from "./run-status-label"

// Tone + dot per status. The pill chrome (tint background, dot, label) reads
// consistently with the order grid's chips via the shared StatusBadge.
const STATUS_STYLES: Record<ListingStatus, { tone: BadgeTone; dot: string }> = {
  open: { tone: "muted", dot: "bg-muted-foreground" },
  importing: { tone: "warning", dot: "bg-warning" },
  imported_with_errors: { tone: "warning", dot: "bg-warning" },
  imported: { tone: "success", dot: "bg-success" },
  failed: { tone: "destructive", dot: "bg-destructive" },
  cancelled: { tone: "muted", dot: "bg-muted-foreground/50" },
}

// The status that means "work is actively happening upstream" — its dot pulses.
const IN_PROGRESS = new Set<ListingStatus>(["importing"])

export function RunStatusBadge({ status }: { status: ListingStatus }) {
  const { tone, dot } = STATUS_STYLES[status]
  return (
    <StatusBadge tone={tone}>
      <span
        className={cn("size-1.5 rounded-full", dot, IN_PROGRESS.has(status) && "animate-pulse")}
      />

      {RUN_STATUS_LABELS[status]}
    </StatusBadge>
  )
}
